import { Model, modelRegistry } from './Model';
import { Shift, CashRegister } from '../models';
import ApiService from '../services/ApiService';
import HashGen from '../utilities/HashGen';
import Money from '../utilities/Money';
import Store from '../wrappers/Store';
import moment from 'moment-timezone';
import { connectionService } from '../services';
export class CashRegisterTransaction extends Model {
    static entity = 'cash_register_transactions';
    static primaryKey = 'hash';
    static syncable = true;
    id = null;
    hash = '';
    cash_register_id = null;
    shift_id = null;
    shift_hash = null;
    amount = '0.0000';
    issued_at = null;
    fiscal_code = null;
    register_status = null;
    registered_at = null;
    created_at = null;
    updated_at = null;
    shift;
    cashRegister;
    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            cash_register_id: this.attr(null),
            shift_id: this.attr(null),
            shift_hash: this.attr(null),
            amount: this.attr('0.0000', value => this.round(value, 4).toFixed(4)),
            issued_at: this.attr(null),
            fiscal_code: this.attr(null),
            register_status: this.attr(null),
            registered_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            shift: this.attr(undefined, value => value ? new Shift(value) : undefined),
            cashRegister: this.attr(undefined, value => value ? new CashRegister(value) : undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    /**
     * Sync the data with the server
     */
    async sync() {
        await this.markForSync('create');
        this.$save();
        if (!Store.get('isOnline')) {
            return { success: true };
        }
        try {
            const response = await ApiService.post(`/cash-registers/transactions`, this.$toJson());
            this.$fill(response.data);
            CashRegisterTransaction.insert({ data: [response.data] });
            CashRegisterTransaction.syncTerminals({ items: [{ action: 'post', record: response.data }] });
            await this.removeFromSync();
            return { success: true };
        }
        catch (error) {
            const isOnline = await connectionService.connectionCheckRetry(5000);
            return { success: isOnline };
        }
    }
    getAmount() {
        return Money.parse(this.amount);
    }
    getIssuedAt() {
        return moment.utc(this.issued_at).local();
    }
}
export default CashRegisterTransaction;
modelRegistry.register('CashRegisterTransaction', CashRegisterTransaction);
//# sourceMappingURL=CashRegisterTransaction.js.map